export default __webpack_public_path__ + "static/media/PiP_Siegel_RZ.f862110a.svg";